<template>
  <div
    v-if="submission"
    class="register_payment_wrapper"
  >
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Register Payment
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-card class="rp_method_container">
      <div class="d-flex justify-content-between align-items-start flex-wrap rp_block_top_row">
        <b-media
          no-body
          class="media_left_rp"
        >
          <b-media-aside>
            <b-avatar
              variant="light-primary"
              size="48"
              rounded
            >
              <img :src="dollarPlusIcon">
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto ml-1">
            <b-card-text class="font-small-3 mb-0 text-primary text-uppercase">
              Making Payment For
            </b-card-text>
            <h4 class="mb-0">
              {{ submission.stringID }} - {{ submission.customerName }}
            </h4>
          </b-media-body>
        </b-media>

        <div class="d-flex rp_amount_right_block">
          <b-media
            no-body
            class="mr-2"
          >
            <b-media-aside>
              <b-avatar
                variant="light-success"
                size="40"
              >
                <img :src="handIcon">
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto ml-1">
              <h4 class="font-weight-bolder mb-0">
                ${{ numberFormat(previouslyPaid) }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Previously Paid
              </b-card-text>
            </b-media-body>
          </b-media>
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                variant="light-warning"
                size="48"
              >
                <feather-icon
                  size="24"
                  icon="DollarSignIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto ml-1">
              <h4 class="font-weight-bolder mb-0">
                ${{ numberFormat(totalAmountDue) }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Total Outstanding
              </b-card-text>
            </b-media-body>
          </b-media>
        </div>
      </div>

      <hr class="rp_hr_1s">

      <b-row class="rp_block_pm_bottom_row">
        <b-col
          cols="12"
          md="6"
          class="rp_block_payment_left_qs"
        >
          <h5 class="mb-2">
            Order Item(s)
          </h5>
          <div
            v-for="item in submission.items"
            :key="item._id"
            class="d-flex justify-content-between align-items-start mb-1 pb-1 border-bottom"
          >
            <div class="order_item_left_rs">
              <div class="font-weight-bold">
                {{ item.stringID }} - {{ item.productType }}
              </div>
              <small class="text-muted">{{ item.lotNo ? `${item.zoneNo}-${item.lotNo}` : item.packageName }}</small>
            </div>
            <div class="text-right order_item_right_rs">
              <div class="text_font_rs_normal">
                ${{ numberFormat(item.amountDue) }}
              </div>
              <small class="text-muted">{{ purchaseOptionLabel(item.paymentType) }}</small>
            </div>
          </div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="rp_block_payment_right_qs"
        >
          <div class="payment_rp_form_section">
            <b-form>
              <b-form-group
                class="payment_amount_group"
                label-class="font-weight-bold"
              >
                <template #label>
                  Amount to be Paid<span class="text-danger">*</span>
                </template>
                <b-input-group prepend="$">
                  <b-form-input
                    :value="numberFormat(totalAmountDue)"
                    disabled
                  />
                </b-input-group>
              </b-form-group>

              <b-form-group label-class="font-weight-bold">
                <template #label>
                  Payment Mode<span class="text-danger">*</span>
                </template>
                <b-form-radio-group
                  v-model="paymentMode"
                  buttons
                  button-variant="outline-primary"
                  class="payment-mode-group pm_method_group"
                  @change="changeCardOption"
                >
                  <b-form-radio
                    v-for="mode in paymentModes"
                    :key="mode.value"
                    :value="mode.value"
                    class="payment-mode-btn"
                  >
                    <img
                      :src="mode.icon"
                      class="payment-mode-icon"
                    >
                    <br>
                    <span>{{ mode.label }}</span>
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="paymentMode === 'Card'">
                <b-form-radio-group
                  v-model="cardOption"
                  buttons
                  button-variant="outline-primary"
                  class="payment-mode-group pm_sub_method"
                  @change="changeCardType"
                >
                  <b-form-radio value="IPP">
                    IPP
                  </b-form-radio>
                  <b-form-radio value="Direct Debit">
                    Direct Debit
                  </b-form-radio>
                  <b-form-radio value="One Time">
                    One Time
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="paymentMode === 'GIRO'">
                <b-form-radio-group
                  v-model="cardOption"
                  buttons
                  button-variant="outline-primary"
                  class="payment-mode-group"
                  @change="changeCardType"
                >
                  <b-form-radio value="Bank Transfer">
                    Bank Transfer
                  </b-form-radio>
                  <b-form-radio value="PayNow">
                    PayNow
                  </b-form-radio>
                  <b-form-radio value="Direct Debit">
                    Direct Debit
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="showCardBrands">
                <b-form-radio-group
                  v-model="cardType"
                  buttons
                  button-variant="outline-primary"
                  class="payment-mode-group pm_sub_method2"
                  @change="changeCardItems"
                >
                  <b-form-radio value="Visa Card">
                    <img
                      :src="visaIcon"
                      class="payment-brand-icon payment_active_bn"
                    >
                  </b-form-radio>
                  <b-form-radio value="Master Card">
                    <img
                      :src="masterCardIcon"
                      class="payment-brand-icon"
                    >
                  </b-form-radio>
                  <b-form-radio value="Amex Card">
                    <img
                      :src="amexIcon"
                      class="payment-brand-icon"
                    >
                  </b-form-radio>
                  <b-form-radio value="China Union Pay">
                    <img
                      :src="unionPayIcon"
                      class="payment-brand-icon"
                    >
                  </b-form-radio>
                  <b-form-radio value="JCB">
                    <img
                      :src="jcbIcon"
                      class="payment-brand-icon"
                    >
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group label-class="font-weight-bold">
                <template #label>
                  Transaction Date<span class="text-danger">*</span>
                </template>
                <flat-pickr
                  v-model="transactionDate"
                  class="form-control"
                  :config="{ dateFormat: 'd/m/Y', maxDate: 'today' }"
                />
              </b-form-group>

              <b-form-group label-class="font-weight-bold">
                <template #label>
                  Payment Reference<span class="text-danger">*</span>
                </template>
                <b-form-input
                  v-model="paymentReference"
                  placeholder="Reference"
                />
              </b-form-group>

              <b-form-group>
                <label class="font-weight-bold">Remarks</label>
                <b-form-textarea
                  v-model="remarks"
                  placeholder="Remarks"
                  maxlength="100"
                  rows="3"
                />
                <small class="text-muted float-right">{{ remarks.length }}/100</small>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-nav class="wrap-border save-nav">
      <li class="nav-item ml-auto">
        <b-button
          type="button"
          variant="flat-primary"
          :to="{ name: 'sales-submissions-show', params: { id: submission._id } }"
        >
          Cancel
        </b-button>
      </li>
      <li class="nav-item mr-1">
        <b-button
          variant="success"
          :disabled="!canSubmit"
          @click="showConfirmModal = true"
        >
          <feather-icon
            icon="DollarSignIcon"
            class="mr-50"
          />
          <span class="align-middle">Register Payment</span>
        </b-button>
      </li>
    </b-nav>

    <b-modal
      v-model="showConfirmModal"
      centered
      hide-header
      hide-footer
    >
      <div class="text-center mb-2 pr_modal_top_row">
        <img
          :src="plusIcon"
          style="width:80px; height: auto;"
        >
        <h4 class="mt-1">
          Proceed with Payment Registration?
        </h4>
        <p class="text-muted">
          You are going to register the following payment of <strong>{{ submission.stringID }}</strong> under <strong>{{ submission.customerName }}</strong>
        </p>
      </div>

      <b-table-simple
        borderless
        responsive
        class="mb-2 pr_modal_table_block"
      >
        <b-thead>
          <b-tr>
            <b-th>Item</b-th>
            <b-th class="text-right">
              Amount
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="item in submission.items"
            :key="item._id"
          >
            <b-td>
              <div>{{ item.stringID }} - {{ item.productType }}</div>
              <small class="text-muted">{{ item.lotNo ? `${item.zoneNo}-${item.lotNo}` : item.packageName }}</small>
            </b-td>
            <b-td class="text-right">
              ${{ numberFormat(item.amountDue) }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2">
              <p class="mb-0">
                <span class="font-weight-bold">Payment Reference</span> {{ paymentReference }}
              </p>
              <p class="mb-0">
                <span class="font-weight-bold">Remarks</span> {{ remarks || '–' }}
              </p>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="d-flex justify-content-between sp_payment_bottom_row">
        <span class="font-weight-bold">{{ transactionDate }}</span>
        <span>
          <span class="font-weight-bold">Total Amount Payable</span>
          ${{ numberFormat(totalAmountDue) }} by {{ paymentMode }}{{ cardOption ? ` - ${cardOption}` : '' }}{{ cardType ? ` - ${cardType}` : '' }}
        </span>
      </div>

      <div class="d-flex justify-content-end mt-2 pr_bottom_btn_group">
        <b-button
          variant="link"
          :disabled="submitting"
          @click="showConfirmModal = false"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          :disabled="submitting"
          @click="submitPayment"
        >
          Proceed
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="showSuccessModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center mb-2 success_modal_pst">
        <b-avatar
          variant="light-success"
          size="80"
        >
          <img
            :src="checkIcon2"
            style="width:80px; height: auto;"
          >
        </b-avatar>
        <h4 class="mt-1">
          Payment Registered
        </h4>
        <p class="">
          Payment for {{ submission.stringID }} under {{ submission.customerName }} ({{ submission.customerNric }}) is successfully registered. These are the Sales Orders:
        </p>
      </div>

      <div class="payment_list_wrapper_sr">
        <div
          v-for="order in createdSalesOrders"
          :key="order._id"
          class="payment_list_single_sr"
        >
          <h5>{{ order.stringID }} - {{ order.productType }}{{ order.lotNo ? ` (${order.zoneNo}-${order.lotNo})` : order.packageName ? ` (${order.packageName})` : '' }}</h5>
          <h6>{{ itemStringID(order) }}</h6>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-1">
        <b-button
          variant="primary"
          :to="{ name: 'sales-submissions-show', params: { id: submission._id } }"
        >
          Done
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BButton, BForm, BFormGroup, BFormInput,
  BFormTextarea, BFormRadioGroup, BFormRadio, BInputGroup, BModal, BTableSimple, BThead, BTbody, BTr, BTh, BTd,
  BNav,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from '@/router/index'

import dollarPlusIcon from '@/assets/images/icons/payments/dollarPlus.png'
import handIcon from '@/assets/images/icons/payments/hand.png'
import plusIcon from '@/assets/images/icons/payments/plus_icon.png'
import checkIcon2 from '@/assets/images/icons/payments/successCheckIcon.png'
import cardIcon from '@/assets/images/icons/payments/credit-card.svg'
import cashIcon from '@/assets/images/icons/payments/dollar.svg'
import giroIcon from '@/assets/images/icons/payments/giro.svg'
import netsIcon from '@/assets/images/icons/payments/nets.svg'
import chequeIcon from '@/assets/images/icons/payments/cheque.svg'
import visaIcon from '@/assets/images/icons/payments/visa.svg'
import masterCardIcon from '@/assets/images/icons/payments/mastercard.svg'
import amexIcon from '@/assets/images/icons/payments/amex.svg'
import unionPayIcon from '@/assets/images/icons/payments/unionPay.svg'
import jcbIcon from '@/assets/images/icons/payments/jcb.svg'
import submissionStoreModule from './submissionStoreModule'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BFormRadio,
    BInputGroup,
    BModal,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BNav,
    flatPickr,
  },
  setup() {
    const SALES_SUBMISSION_APP_STORE_MODULE_NAME = 'app-sales-submissions'
    if (!store.hasModule(SALES_SUBMISSION_APP_STORE_MODULE_NAME)) store.registerModule(SALES_SUBMISSION_APP_STORE_MODULE_NAME, submissionStoreModule)

    const toast = useToast()
    const submission = ref(null)
    // Counter payment is a once-off finalization (registerPayment creates every item's SalesOrder
    // in the same call) - there's no prior partial-payment history to show for this flow.
    const previouslyPaid = ref(0)

    store.dispatch('app-sales-submissions/fetchSubmission', router.currentRoute.params.id)
      .then(response => {
        submission.value = response.data
      })

    // Payment-success modal shows each new SalesOrder alongside the SalesSubmissionItem it was
    // created from ("SS00001-A") - the registerPayment response only carries submissionItemID
    // (an ObjectId ref), not that item's own stringID, so look it up from the already-loaded
    // submission's own items.
    const itemStringID = order => {
      const item = submission.value.items.find(i => i._id === order.submissionItemID)
      return item ? item.stringID : ''
    }

    const purchaseOptionLabel = paymentType => {
      if (paymentType === 'downpayment') return 'Pay Downpayment'
      if (paymentType === 'bookingfee') return 'Pay Booking Fee'
      return 'Full Payment'
    }

    // submission.totalPayable is a snapshot written once when the submission was originally
    // finalized - if items are edited afterward (the admin edit-items flow) it drifts from the
    // items' live amounts. The backend registerPayment endpoint never reads it either; it sums
    // each item's own live amountDue to create the SalesOrders, so that's the true amount charged.
    const totalAmountDue = computed(() => (submission.value ? submission.value.items.reduce((sum, item) => sum + (Number(item.amountDue) || 0), 0) : 0))

    const paymentModes = [
      {
        value: 'Card',
        label: 'Card',
        icon: cardIcon,
      },
      {
        value: 'Cash',
        label: 'Cash',
        icon: cashIcon,
      },
      {
        value: 'GIRO',
        label: 'GIRO',
        icon: giroIcon,
      },
      {
        value: 'NETS',
        label: 'NETS',
        icon: netsIcon,
      },
      {
        value: 'Cheque',
        label: 'Cheque',
        icon: chequeIcon,
      },
    ]

    const paymentMode = ref(null)
    const cardOption = ref('')
    const cardType = ref('')
    const transactionDate = ref(new Date().toLocaleDateString('en-GB'))
    const paymentReference = ref('')
    const remarks = ref('')
    const showConfirmModal = ref(false)
    const showSuccessModal = ref(false)
    const submitting = ref(false)
    const createdSalesOrders = ref([])

    const showCardBrands = computed(() => (paymentMode.value === 'Card' && ['IPP', 'Direct Debit', 'One Time'].includes(cardOption.value))
      || (paymentMode.value === 'GIRO' && cardOption.value === 'Direct Debit'))

    const canSubmit = computed(() => !!(paymentMode.value && transactionDate.value && paymentReference.value) && remarks.value.length <= 100)

    // Mirrors the same auto-suggestion behaviour as views/customer/payment/RegisterPayment.vue -
    // Payment Reference defaults to whatever payment-mode/card-brand combination is picked, but
    // stays editable since staff sometimes need to record a different reference (e.g. a receipt no.).
    const changeCardOption = () => {
      cardOption.value = ''
      cardType.value = ''
      if (paymentMode.value === 'Cheque') {
        paymentReference.value = ''
      } else if (paymentMode.value === 'Card') {
        cardOption.value = 'One Time'
        cardType.value = 'Visa Card'
        paymentReference.value = 'Visa Card'
      } else if (paymentMode.value === 'GIRO') {
        cardOption.value = 'Bank Transfer'
        paymentReference.value = 'Bank Transfer'
      } else {
        paymentReference.value = paymentMode.value
      }
    }

    const changeCardType = () => {
      cardType.value = ''
      if (cardOption.value === 'Bank Transfer' || cardOption.value === 'PayNow') {
        paymentReference.value = cardOption.value
      } else {
        paymentReference.value = ''
      }
    }

    const changeCardItems = () => {
      paymentReference.value = cardType.value
    }

    const submitPayment = () => {
      submitting.value = true
      store.dispatch('app-sales-submissions/registerPayment', {
        id: submission.value._id,
        formData: {
          paymentMode: paymentMode.value,
          transactionDate: transactionDate.value,
          paymentReference: paymentReference.value,
          remarks: remarks.value,
        },
      })
        .then(response => {
          createdSalesOrders.value = response.data.salesOrders
          showConfirmModal.value = false
          showSuccessModal.value = true
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          submitting.value = false
        })
    }

    return {
      submission,
      previouslyPaid,
      totalAmountDue,
      dollarPlusIcon,
      handIcon,
      plusIcon,
      checkIcon2,
      visaIcon,
      masterCardIcon,
      amexIcon,
      unionPayIcon,
      jcbIcon,
      paymentModes,
      paymentMode,
      cardOption,
      cardType,
      showCardBrands,
      transactionDate,
      paymentReference,
      remarks,
      showConfirmModal,
      showSuccessModal,
      submitting,
      createdSalesOrders,
      canSubmit,
      changeCardOption,
      changeCardType,
      changeCardItems,
      submitPayment,
      purchaseOptionLabel,
      itemStringID,
    }
  },
}
</script>

<style lang="scss" scoped>
.payment-mode-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.payment-mode-btn {
  min-width: 90px;
  text-align: center;
}
.payment-mode-icon {
  width: 24px;
  height: 24px;
}
.payment-brand-icon {
  height: 24px;
}
</style>
